import { render, staticRenderFns } from "./PartnerTypeLabel.vue?vue&type=template&id=83adf318&scoped=true"
import script from "./PartnerTypeLabel.vue?vue&type=script&lang=ts"
export * from "./PartnerTypeLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83adf318",
  null
  
)

export default component.exports